import { UniqueUserId, UserClickFields, ViewContentFields } from '@xylabs/pixel'

import { CoinUserEventHandlerBase } from './CoinUserEventHandlerBase'
import { CustomProperties } from './CustomProperties'
import { TestData } from './TestData'
import { Cart } from 'business-logic/cart/hooks'
import { mixpanelTrackEvent } from '../mixpanel'

export class MixpanelEventHandler<T extends Record<string, unknown>> extends CoinUserEventHandlerBase<T> {
  async emailCollected(_fields: { email: string }) {
  }

  async accountCreated() {
    //
  }

  async shareCompleted() {
    //
  }

  async buyticketsCompleted() {
    //
  }

  async installCompleted() {
    //
  }

  async funnelCompleted() {
    //
  }

  async offerRequested() {
    //
  }

  async feedbackScoreCollected() {
    //
  }

  async feedbackSourceCollected() {
    //
  }

  async goodFeedbackRequested() {
    //
  }

  async badFeedbackRequested() {
    //
  }

  async contactInfoComplete() {
    mixpanelTrackEvent('Contact Info Complete', this.buildCustomProperties())
  }

  async addressInfoComplete() {
    mixpanelTrackEvent('Address Info Complete', this.buildCustomProperties())
  }

  async paymentInfoComplete() {
    mixpanelTrackEvent('Payment Info Complete', this.buildCustomProperties())
  }

  async addToCart() {
    mixpanelTrackEvent('Add To Cart', this.buildCustomProperties())
  }

  async purchaseCompleted() {
    const cart = Cart.get()

    mixpanelTrackEvent('Purchase', this.buildCustomProperties({
      currency: 'USD',
      price: cart.getValue(),
    }))
  }

  async userClick(fields: UserClickFields) {
    mixpanelTrackEvent('User Click', this.buildCustomProperties(fields))
  }

  async initiateCheckout() {
    mixpanelTrackEvent('Initiate Checkout', this.buildCustomProperties())
  }

  async purchaseAttempted() {
    //
  }

  async purchaseFailed() {
    //
  }

  async upsellViewed() {
    //
  }

  async upsellUnavailable() {
    //
  }

  async upsellAccepted() {
    //
  }

  async trialStarted() {
    //
  }

  async funnelStarted() {
    //
  }

  async upsellSucceeded() {
    await this.purchaseCompleted()
  }

  async upsellFailed() {
    //
  }

  async testStarted() {
    //
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async customEvent(name: string, data: T) {
    //
  }

  async viewContent(fields: ViewContentFields) {
    // mixpanelTrackEvent('View Content', this.buildCustomProperties(fields))
    // await this.events.viewContent().send(this.buildCustomProperties<ViewContentFields>(fields))
  }

  buildCustomProperties<T>(data?: T): T | CustomProperties {
    const cart = Cart.get()
    const coinId = new UniqueUserId().id
    const testData = new TestData().data
    const cartItems = cart.getItems()?.map((item) => ({
      planId: item.planId,
      quantity: item.quantity || 1,
      price: item.price || 0,
    }))
    return {
      ...data,
      coinId,
      cart: cart.getItemSet(),
      cartItems,
      testData,
    }
  }
}
